// src/components/sampleOrders/sampleOrderItemUtils.js

/**
 * Given a sample request document, returns:
 * - totalItems: main item + additionalItems length
 * - extraItems: how many "extra" items beyond the first
 */
export function getItemCountsForRequest(request) {
    if (!request) {
      return { totalItems: 0, extraItems: 0 };
    }
  
    const base = 1; // main product
    const extras = Array.isArray(request.additionalItems)
      ? request.additionalItems.length
      : 0;
  
    const totalItems = base + extras;
    const extraItems = Math.max(0, totalItems - 1);
  
    return { totalItems, extraItems };
  }
  